<template>
  <div class="tableWithPerPageSelection pd-10px">
    <div class="columns level-right">
      <div class="columns">
        <div class="column">
          <exportExcelButton
            :perm="constantes.bonStockPerm.exporter"
            :query="exportExcelQuery"/>
        </div>
        <div class="column">
          <parametrage-table
            :referenceTable="referenceTable"
            @endLoadParamtre="startArrayRendering = true">
          </parametrage-table>
        </div>
      </div>
    </div>
    <div class="columns is-multiline is-vcentered">
      <div class="mgl-10px">
        <div class="columns is-multiline">
          <div class="column is-narrow">
            <div class="card pd-10px">
              {{ $t('mouvementStock.solde' )}} :
              <span class="right">
                {{ solde }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-server-table
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      class="tableWithChildRow"
      :ref="referenceTable"
      v-if="startArrayRendering && mountedLoadingEnd">
      <div slot="dateMouvement" slot-scope="props">
        {{  func.formatDate(props.row.bonStock.dateBon) }}
      </div>
      <div slot="origine" slot-scope="props">
        {{ getOrigineLibelle(props.row) }}
        <template v-if="props.row.bonStock.reference">
          <router-link-blank
            :to="{ name: 'c.bodac.commandes',
            params: {id: props.row.bonStock.reference.id}}"
            :message="props.row.bonStock.reference.code">
          </router-link-blank>
        </template>
      </div>
      <div slot="quantite" slot-scope="props">
        <div class="is-pulled-right is-1">
          {{ props.row.quantite }}
        </div>
      </div>
      <div slot="dateBon" slot-scope="props">
        <template>
          <router-link-blank
            :to="{ name: detailRoute(props.row),
            params: {id: props.row.bonStock.id}}"
            :message="func.formatDate(props.row.bonStock.dateBon)">
          </router-link-blank>
        </template>
      </div>
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"
        />
      </template>
    </v-server-table>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import formatDateIso from '@/services/general/formatIsoDate';
import { BON_STOCK } from '@/configuration/bonStock/permissionsStockConf';
import {
  SORT_ICON,
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  TEXTS,
} from '@/configuration/clientTableConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { REFERENCE_TABLE_MOUVEMENTS_STOCK } from '@/configuration/general/referenceTableConf';
import messageErreur from '@/services/general/messageErreur';
import formatDate from '@/services/general/formatDate';
import TableItemsInView from '@/components/general/TableItemsInView';
import parametrageTable from '@/components/general/parametrageTable';
import {
  DETAILS_BON_ENTREE_ROUTE,
  DETAILS_BON_SORTIE_ROUTE,
  EXPORT_EXCEL_MOUVEMENT_STOCK,
  BON_STOCK_TYPE_ENTREE,
  BON_STOCK_TYPE_SORTIE,
} from '@/configuration/bonStock/menuStockConf';
import exportExcelButton from '@/components/general/button/exportExcelButton';

const MouvementStock = createNamespacedHelpers('mouvementStock');
const Societe = createNamespacedHelpers('societe');

export default {
  components: {
    routerLinkBlank,
    parametrageTable,
    exportExcelButton,
    TableItemsInView,
  },
  props: {
    tiersInformation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      referenceTable: REFERENCE_TABLE_MOUVEMENTS_STOCK,
      resultPerPage: RESULTS_PER_PAGE,
      startArrayRendering: false,
      mountedLoadingEnd: false,
      func: {
        formatDate,
      },
      constantes: {
        bonEntrePath: DETAILS_BON_ENTREE_ROUTE,
        bonSortiePath: DETAILS_BON_SORTIE_ROUTE,
        bonStockPerm: BON_STOCK,
        entree: BON_STOCK_TYPE_ENTREE,
        sortie: BON_STOCK_TYPE_SORTIE,
      },
    };
  },
  computed: {
    ...MouvementStock.mapGetters({
      mouvementsStock: 'items',
      criteresRecherche: 'critereRechercheMouvementStock',
      solde: 'solde',
      total: 'total',
      lastPayload: 'lastPayload',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    columns() {
      return [
        'dateBon',
        'origine',
        'produit.libelle',
        'quantite',
        'bonStock.commentaire',
      ];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          origine: this.$t('mouvementStock.table.origine'),
          'produit.libelle': this.$t('mouvementStock.table.produit'),
          quantite: this.$t('mouvementStock.table.quantite'),
          dateBon: this.$t('mouvementStock.table.lienVersBonStock'),
          'bonStock.commentaire': this.$t('mouvementStock.table.commentaire'),
        },
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        columnsClasses: {
          dateBon: 'colonneWidth130px ',
          quantite: 'colonneWidth130px',
          'bonStock.commentaire': 'width-960',
          origine: 'colonneCommentaire ',
        },
        filterable: false,
        sortable: this.columns.filter(column => column !== 'quantite'),
        requestFunction: ((data) => {
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          data.query.societeId = this.societeActiveId;
          data.query.tiersId = this.tiersInformation.id;
          return this.actionsLoadMouvement(data)
            .catch(() => {
              this.finLoading();
              messageErreur(this.$i18n);
            });
        }),
        responseAdapter: (() => {
          return {
            data: this.mouvementsStock,
            count: this.total,
          };
        }),
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_MOUVEMENT_STOCK,
        typeExport: '',
        filtres: this.lastPayload,
      };
    },
  },
  methods: {
    ...MouvementStock.mapActions({
      actionsLoadMouvement: 'loadMouvementStock',
      actionsLoadSoldeMouvement: 'loadSoldeMouvementStock',
    }),
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    getOrigineLibelle(row) {
      if (row.bonStock.origine === 'BonDivers') {
        return this.$t('mouvementStock.produit.bonDivers');
      }
      return '';
    },
    detailRoute(row) {
      return this.isEntree(row) ? this.constantes.bonEntrePath : this.constantes.bonSortiePath;
    },
    isEntree(row) {
      return row.bonStock.type === this.constantes.entree;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    if (this.tiersInformation.id) {
      try {
        await this.actionsLoadSoldeMouvement({
          tiersIds: [this.tiersInformation.id],
          dateSolde: formatDateIso(new Date()),
        });
        this.mountedLoadingEnd = true;
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
        this.setInformationPage(this.$t('pageGeneral.detail', { item: this.tiersInformation.nomCommercial }));
      }
    }
  },
};
</script>
